import { SplineSceneController } from '../lib/SplineSceneController';

export function initSplineScene(parent) {
  const canvas = parent.querySelector('canvas[data-spline-url]');
  if (!canvas) return;

  const sceneURL = canvas.dataset.splineUrl;

  const poster = parent.querySelector('picture[data-is-spline-poster]') ?? null;
  const fallback =
    parent.querySelector('picture[data-is-spline-fallback]') ?? null;
  const scene = new SplineSceneController({
    canvas,
    parent,
    poster,
    fallback,
    sceneURL,
    useFirstLoadDelays: true,
    // takeScreenshot: true,
    // takeScreenshot: 5000,
  });
  scene.init().then();
}

export function initAllSplineScenes(selector = '.js-spline-scene') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initSplineScene(block));
}
